import { render } from "./SerenePrivacyPolicyEN.vue?vue&type=template&id=2b597421"
import script from "./SerenePrivacyPolicyEN.vue?vue&type=script&lang=js"
export * from "./SerenePrivacyPolicyEN.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__